module.exports=function(scope){ return `<iframe title="" class="previewIframe" src="${scope.url}"></iframe>`};